<template>
  <div>
    <ImageUploader 
      v-if="((hideAfterCrop)?croppedSrc == '':true) && imgSrc == ''"
      @image-loaded="handleImageLoaded"
      @selecting-image="emitImageSelected('')"
    >
      <template v-slot:link="{handle}">
        <slot name="link" :handle="handle">
        </slot>
      </template>
      <template v-slot:uploaderActions="{handles}">
        <slot name="uploaderActions" :handles="handles">
        </slot>
      </template>
    </ImageUploader>
    <ImageCropper
      hide-preview
      v-if="!imgSrc == ''"
      :img-src="imgSrc"
      @image-cropped="handleImageCropped"
      @cropping-canceled="handleCroppingCanceled"
    >
      <template v-slot:cropperActions="{handles}">
        <slot name="cropperActions" :handles="handles">
        </slot>
      </template>
    </ImageCropper>
    <template v-if="croppedSrc !== '' && showCropped">
      <img :src="croppedSrc" />
    </template>
  </div>
</template>

<script>
import ImageUploader from './ImageUploader';
import ImageCropper from './ImageCropper';

export default {
  props:{
    value:String,
    hidePreview:Boolean,
    hideAfterCrop:Boolean,
    showCropped:Boolean
  },
  name: 'ImageSelector',
  components: {
    ImageUploader,
    ImageCropper
  },
  data() {
    return {
      imgSrc:'',
      croppedSrc:'',
      link:''
    };
  },
  watch:{
    value(v){
      this.croppedSrc = v
    }
  },
  mounted(){
    if(this.value)
      this.croppedSrc = this.value
  },
  methods: {
    // events
    handleImageLoaded(event) {
      this.imgSrc = event
      this.$emit('start');
    },
    handleImageCropped(event) {
      this.imgSrc = ''
      this.emitImageSelected(event);
    },
    handleCroppingCanceled() {
      this.imgSrc = ''
      this.emitImageSelected('')
    },
    emitImageSelected(data) {
      this.$emit('end');
      this.croppedSrc = data
      this.$emit('input', data);
    }
  }
}
</script>
